import { useServerNow } from "../api/useServerNow";

/** Order deadline checks on the client — Firebase server time only; undefined while RTDB offset loads. */
export function useOrderDeadlineAt(): Date | undefined {
    return useServerNow();
}
